import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { mapProductFieldsToBody } from './mappers/productMapper';
import type { ProductAdminResponse, UpdateProductParams } from './types';

export async function updateProduct(productId: string, params: UpdateProductParams) {
  const url = `/web/studio/products/${productId}`;

  const { isActive, destroyed, price, ...fields } = params;
  /* eslint-disable camelcase */
  const body = {
    ...mapProductFieldsToBody(fields),
    ...(isActive !== undefined && { is_active: isActive }),
    ...(destroyed !== undefined && { destroyed }),
    ...(price !== undefined && { price }),
  };
  /* eslint-enable camelcase */

  const response = await api.executePutRequest<ObjectResponse<ProductAdminResponse>>(url, body);

  return response.data;
}
